import PropTypes from 'prop-types';
import { createContext, useState } from 'react';

const PlateformeUtilitiesContext = createContext({});

export const PlateformeUtilitiesProvider = ({ children }) => {

    PlateformeUtilitiesProvider.propTypes = {
        children: PropTypes.any
    };
    const [sideBarOpen, setSideBarOpen] = useState(false);
    const [backdropOpen, setBackdropOpen] = useState(false);
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState('');
    const [isSnackBarError, setIsSnackBarError] = useState(false); // if it is an error, it should be a read snackbar: danger

    const [remoteCountriesData, setRemoteCountriesData] = useState([]);
    const [errors, setErrors] = useState({});
    const [showErrors, setShowErrors] = useState(false);

    return (
        <PlateformeUtilitiesContext.Provider
            value={{
                sideBarOpen, setSideBarOpen,
                backdropOpen, setBackdropOpen,
                openSnackBar,setOpenSnackBar,
                snackBarMessage, setSnackBarMessage,
                // DATA OF cities - regions - pays
                remoteCountriesData, setRemoteCountriesData,
                errors, setErrors,
                showErrors, setShowErrors,
                isSnackBarError, setIsSnackBarError
            }}
        >
            {children}
        </PlateformeUtilitiesContext.Provider>
    );
};

export default PlateformeUtilitiesContext;